module.exports = __webpack_public_path__ + "img/smartscreen1.b7fb5087.png";